export interface BrandingTheme {
  primary_color: string;
  secondary_color: string | null;
  header_background_color: string;
  header_text_color: string;
  background_mode: 'dark' | 'light';
}

export type HeaderBlockType =
  | 'partner_logo'
  | 'app_logo'
  | 'app_name_text'
  | 'hamburger_menu'
  | 'search_icon'
  | 'search_bar'
  | 'language_selector'
  | 'custom_icon'
  | 'spacer'
  | 'reward_gift';

export interface HeaderBlock {
  type: HeaderBlockType;
  url?: string;
  icon?: string;
  color?: string;
  text?: string;
  width?: number;
  height?: number;
}

export interface HeaderRow {
  left?: HeaderBlock[];
  center?: HeaderBlock[];
  right?: HeaderBlock[];
  background_color?: string;
  height?: number;
  is_separator?: boolean;
  separator_color?: string;
  separator_thickness?: number;
}

export interface HeaderLayout {
  rows: HeaderRow[];
}

export interface AuthConfig {
  apple_signin: boolean;
  google_signin: boolean;
  email: boolean;
  msisdn: boolean;
}

export interface UiOverrides {
  badge_trending_color?: string;
  badge_new_color?: string;
  [key: string]: any;
}

export interface CampaignUiConfig {
  id: string;
  campaign_countries_languages_id: string;
  theme: BrandingTheme;
  header_layout: HeaderLayout;
  auth_config: AuthConfig;
  ui_overrides: UiOverrides;
}

export const DEFAULT_BRANDING_THEME: BrandingTheme = {
  primary_color: '#A855F7',
  secondary_color: null,
  header_background_color: '#1a1a1a',
  header_text_color: '#ffffff',
  background_mode: 'dark',
};

export const DEFAULT_HEADER_LAYOUT: HeaderLayout = {
  rows: [
    {
      left: [
        { type: 'hamburger_menu' },
        { type: 'app_logo' },
      ],
      center: [],
      right: [
        { type: 'reward_gift' },
        { type: 'search_icon' },
      ],
    },
  ],
};

export const DEFAULT_AUTH_CONFIG: AuthConfig = {
  apple_signin: true,
  google_signin: true,
  email: true,
  msisdn: true,
};
